import ItemDetailAPI from "../model/API/ItemDetailType";

export const ItemDetail: ItemDetailAPI = {
    icon:"http://services.runescape.com/m=itemdb_rs/4856_obj_sprite.gif?id=21787",
    icon_large:"http://services.runescape.com/m=itemdb_rs/4856_obj_big.gif?id=21787",
    id:21787,
    type:"Miscellaneous",
    typeIcon:"http://www.runescape.com/img/categories/Miscellaneous",
    name:"Espada Divina de Armadyl",
    description: "A beautiful, heavy sword.",
    current:{
        trend:"neutral",
        price:"17.0m"
    },
    today:{
        trend:"positive",
        price:"+897.2k"
    },
    members: true,
    day30:{
        trend: "positive",
        change:"+27.0%"
    },
    day90:{
        trend:"positive",
        change:"+30.0%"
    },
    day180:{
        trend:"positive",
        change:"+8.0%"
    }
};